import Skeleton from '@mui/material/Skeleton';
import { SkeletonRow } from './SkeletonTypes';

interface CircleTextSkeletonProps {
  circleSize: number;
  rows: SkeletonRow[];
  gap: number;
  rowsGap?: number;
}

export default function CircleTextSkeleton({ circleSize, rows, gap, rowsGap }: CircleTextSkeletonProps) {
  return (
    <div style={{ display: 'flex', alignItems: 'flex-start', gap }}>
      <Skeleton variant="circular" width={circleSize} height={circleSize} animation="pulse" sx={{ bgcolor: 'var(--surface-grey-lighter)' }} />
      <div style={{ display: 'flex', flexDirection: 'column', gap: rowsGap }}>
        {rows.map((row, index) => (
          <Skeleton
            key={index}
            variant="text"
            width={row.width}
            height={row.height || '10px'}
            animation="pulse"
            sx={{ bgcolor: 'var(--surface-grey-lighter)' }}
          />
        ))}
      </div>
    </div>
  );
}
